import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { IgxGridComponent } from '@infragistics/igniteui-angular/grids/grid';
import { AutocompleteComponent, AutocompleteFilterCallback } from "@tylertech/forge";
import { ForgeAutocompleteProxyModule, ForgeTextFieldModule } from "@tylertech/forge-angular";

interface SearchOption
{
    label: string;
    value: string;
}

@Component({
    selector: "column-move-selector",
    templateUrl: "./columnMoveSelector.tmpl.html",
    imports: [
        ForgeAutocompleteProxyModule,
        ForgeTextFieldModule,
    ]
})
export class ColumnMoveSelectorComponent
{
    @Input() grid: IgxGridComponent;

    @Input() column: any;

    @Input() columns: any[];

    @ViewChild("autocomplete") readonly autocomplete: AutocompleteComponent;

    @ViewChild("autocompleteInput") private autocompleteInput: ElementRef;

    currentColumnSelection: string;

    autocompleteFilter: AutocompleteFilterCallback;

    columnSelectionMode(field: string): boolean
    {
        return this.currentColumnSelection === field;
    }

    toggleColumnSelectionMode(event: PointerEvent, field: string): void
    {
        event.preventDefault();
        event.stopPropagation();
        this.currentColumnSelection = field;
        this.autocompleteFilter = this.getItems.bind(this);
        requestAnimationFrame(() =>
        {
            this.autocomplete.open = true;
            this.autocompleteInput.nativeElement.focus();
        });
    }

    private getItems(searchText: string): Promise<SearchOption[]>
    {
        return Promise.resolve(this.applyFilter(searchText));
    }

    private applyFilter(searchText: string): SearchOption[]
    {
        const filtered = this.columns
            .filter(x =>
            {
                if (!x.Visible)
                    return false;
                if (!searchText)
                    return true;
                return x.Label.toLowerCase().indexOf(searchText.toLowerCase()) >= 0;
            })
            .slice(0, 20);
        return filtered.map(x => <SearchOption>{ label: x.Label, value: x.Name });
    }

    onSelectedItemChange($event: Event): void
    {
        if (this.autocomplete.value)
            this.columnSelected(this.autocomplete.value);
    }

    columnSelected(changeTo: string): void
    {
        if (changeTo)
        {
            const movingColumn = this.grid.getColumnByName(changeTo);
            const targetColumn = this.grid.getColumnByName(this.currentColumnSelection);
            this.grid.moveColumn(movingColumn, targetColumn, 0);
        }
        this.close();
    }

    close(): void
    {
        this.currentColumnSelection = undefined;
    }
}
